import PropTypes from "prop-types"

import TagShape from "./TagShape"
import TierShape from "./TierShape"
import UserShape from "./UserShape"
import AssetShape from "./AssetShape"
import PartnerShape from "./PartnerShape"
import PropertyShape from "./PropertyShape"
import ProjectValidationErrorShape from "./ProjectValidationErrorShape"


const ProjectShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(TagShape),
  type: PropTypes.string.isRequired,
  amount: PropTypes.number,
  documents: PropTypes.arrayOf(AssetShape),
  closeDate: PropTypes.string,
  coverImageUrl: PropTypes.string,
  investmentSubjects: PropTypes.arrayOf(PropertyShape),
  tiers: PropTypes.arrayOf(TierShape).isRequired,
  partners: PropTypes.arrayOf(PartnerShape),
  brokers: PropTypes.arrayOf(UserShape),
  bankAccountId: PropTypes.string,
  validationErrors: PropTypes.arrayOf(ProjectValidationErrorShape),
})

export default ProjectShape
